import { render, staticRenderFns } from "./AiPhraseRecordViewer.vue?vue&type=template&id=3d262311&scoped=true&"
import script from "./AiPhraseRecordViewer.vue?vue&type=script&lang=ts&"
export * from "./AiPhraseRecordViewer.vue?vue&type=script&lang=ts&"
import style0 from "./AiPhraseRecordViewer.vue?vue&type=style&index=0&id=3d262311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d262311",
  null
  
)

export default component.exports